import PatFail from "../../../../football/rules/offensive/pat/pat-fail";
import FootballState from "../../../../football/state/football-state";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

export default class FlagPatFail extends PatFail {
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        if (
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        ) {
            return true;
        }

        // An intercepted try that was not returned for points still ends the
        // try; the defense receives the ball. FlagPatDefenseComplete runs
        // first in the tree and sets playPoints when the return scored.
        return (
            ruleContext.PAT &&
            !ruleContext.playPoints &&
            play.historyContains(FootballState.PassIntercepted) &&
            [FootballState.EndOfPlay, FootballState.NoPenaltyEndOfPlay].some(
                (state) => state === fragment.associatedState
            )
        );
    }

    switchPossession(gameContext) {
        // Without kickoffs the ball goes straight to the other team after a
        // PAT, so flag switches possession here. With kickoffs enabled the
        // scoring team keeps the ball to kick off - which is why the base
        // hook is a no-op for tackle - and the receiving team takes over on
        // the kickoff outcome instead. Switching here would place the kickoff
        // on the receiving team's side and have the wrong team kicking.
        if (isKickoffEnabled(gameContext)) return;

        gameContext.switchPossession();
    }
}
